import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import FilterBar from 'common/components/organisms/FilterBar';

/**
 * Assets-specific wrapper around the shared FilterBar. Translates the
 * Assets i18n keys (assets.filterBar.*) and the labelKey/def option shapes into
 * the plain pre-translated props FilterBar expects, and supplies the Assets
 * cucumber test-ids. All Assets behaviour and selectors are unchanged.
 */
const AppliedFilterBar = ({
  presets, sortOptions, groupOptions, t, ...rest
}) => {
  const labels = {
    addFilter: t('assets.filterBar.addFilter', { defaultValue: 'Filter' }),
    filterBy: t('assets.filterBar.filterBy', { defaultValue: 'Filter by' }),
    filterByPlaceholder: t('assets.filterBar.filterByPlaceholder', { defaultValue: 'Filter by…' }),
    remove: t('assets.filterBar.remove', { defaultValue: 'Remove' }),
    insights: t('assets.filterBar.insights', { defaultValue: 'Insights' }),
    clearAll: t('assets.filterBar.clearAll', { defaultValue: 'Clear all' }),
    quick: t('assets.filterBar.quick', { defaultValue: 'Quick' }),
    sort: t('assets.filterBar.sort', { defaultValue: 'Sort' }),
    group: t('assets.filterBar.group', { defaultValue: 'Group' })
  };

  return (
    <FilterBar
      {...rest}
      labels={labels}
      testIds={{ addButton: 'asset-filter-add-button', fieldOption: 'asset-filter-field-option' }}
      presets={(presets || []).map(p => ({ id: p.id, dot: p.dot, label: t(p.labelKey, { defaultValue: p.def }) }))}
      sortOptions={(sortOptions || []).map(o => ({ value: o.value, label: t(o.labelKey, { defaultValue: o.def }) }))}
      groupOptions={(groupOptions || []).map(o => ({ value: o.value, label: t(o.labelKey, { defaultValue: o.def }) }))}
    />
  );
};

AppliedFilterBar.propTypes = {
  presets: PropTypes.arrayOf(PropTypes.object),
  sortOptions: PropTypes.arrayOf(PropTypes.object),
  groupOptions: PropTypes.arrayOf(PropTypes.object),
  t: PropTypes.func.isRequired
};

AppliedFilterBar.defaultProps = {
  presets: [],
  sortOptions: [],
  groupOptions: []
};

export default withTranslation()(AppliedFilterBar);
